import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import adminProductService from "../../services/adminProductService";
import api from "services/api";

// ===== EXISTING CRUD THUNKS =====
export const createProductThunk = createAsyncThunk(
  "adminProduct/createProduct",
  async (productData, { rejectWithValue }) => {
    try {
      const response = await adminProductService.createProduct(productData);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateProductByIdThunk = createAsyncThunk(
  "adminProduct/updateProductById",
  async ({ id, productData }, { rejectWithValue }) => {
    try {
      const response = await adminProductService.updateProductById(
        id,
        productData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateProductStatusByIdThunk = createAsyncThunk(
  "adminProduct/updateProductStatusById",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await adminProductService.updateProductStatusById(
        id,
        status
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const deleteProductByIdThunk = createAsyncThunk(
  "adminProduct/deleteProductById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await adminProductService.deleteProductById(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const getProductByIdThunk = createAsyncThunk(
  "adminProduct/getProductById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await adminProductService.getProductById(id);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const getAllProductsThunk = createAsyncThunk(
  "adminProduct/getAllProducts",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await adminProductService.getAllProducts(filters);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// ===== NEW PRICING THUNKS =====
export const getProductWithPricingThunk = createAsyncThunk(
  "adminProduct/getProductWithPricing",
  async ({ id, options }, { rejectWithValue }) => {
    try {
      const response = await adminProductService.getProductWithPricing(
        id,
        options
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// ===== NEW STOCK MANAGEMENT THUNKS =====
export const updateLocationStockThunk = createAsyncThunk(
  "adminProduct/updateLocationStock",
  async ({ id, stockData }, { rejectWithValue }) => {
    try {
      const response = await adminProductService.updateLocationStock(
        id,
        stockData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const transferStockThunk = createAsyncThunk(
  "adminProduct/transferStock",
  async (transferData, { rejectWithValue }) => {
    try {
      const response = await adminProductService.transferStock(transferData);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const getLowStockProductsThunk = createAsyncThunk(
  "adminProduct/getLowStockProducts",
  async (params, { rejectWithValue }) => {
    try {
      const response = await adminProductService.getLowStockProducts(params);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const reserveStockThunk = createAsyncThunk(
  "adminProduct/reserveStock",
  async (reservationData, { rejectWithValue }) => {
    try {
      const response = await adminProductService.reserveStock(reservationData);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const checkAvailabilityThunk = createAsyncThunk(
  "adminProduct/checkAvailability",
  async ({ id, quantity }, { rejectWithValue }) => {
    try {
      const response = await adminProductService.checkAvailability(
        id,
        quantity
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// ===== NEW BRANCH/STORE THUNKS =====
export const getProductsByBranchThunk = createAsyncThunk(
  "adminProduct/getProductsByBranch",
  async ({ branchCode, params }, { rejectWithValue }) => {
    try {
      const response = await adminProductService.getProductsByBranch(
        branchCode,
        params
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const syncBranchInventoryThunk = createAsyncThunk(
  "adminProduct/syncBranchInventory",
  async (inventoryData, { rejectWithValue }) => {
    try {
      const response = await adminProductService.syncBranchInventory(
        inventoryData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// ===== NEW BULK OPERATIONS THUNKS =====
export const bulkUpdateProductsThunk = createAsyncThunk(
  "adminProduct/bulkUpdateProducts",
  async (updates, { rejectWithValue }) => {
    try {
      const response = await adminProductService.bulkUpdateProducts(updates);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const importProductsThunk = createAsyncThunk(
  "adminProduct/importProducts",
  async ({ file, defaultBranch }, { rejectWithValue }) => {
    try {
      const response = await adminProductService.importProducts(
        file,
        defaultBranch
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const exportProductsThunk = createAsyncThunk(
  "adminProduct/exportProducts",
  async (params, { rejectWithValue }) => {
    try {
      const response = await adminProductService.exportProducts(params);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// ===== NEW HALLMARK THUNKS =====
export const updateHallmarkThunk = createAsyncThunk(
  "adminProduct/updateHallmark",
  async ({ id, hallmarkData }, { rejectWithValue }) => {
    try {
      const response = await adminProductService.updateHallmark(
        id,
        hallmarkData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const verifyHallmarkThunk = createAsyncThunk(
  "adminProduct/verifyHallmark",
  async (huid, { rejectWithValue }) => {
    try {
      const response = await adminProductService.verifyHallmark(huid);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Get applicable pricing rules for a product
export const getApplicablePricingRulesThunk = createAsyncThunk(
  "pricingRules/getApplicable",
  async (productId, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/admin-product/${productId}/applicable-rules`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Failed to fetch applicable rules"
      );
    }
  }
);

// Get product's currently assigned pricing rules
export const getProductPricingRulesThunk = createAsyncThunk(
  "pricingRules/getProductRules",
  async (productId, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/admin-product/${productId}/pricing-rules`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Failed to fetch product pricing rules"
      );
    }
  }
);

// Assign a pricing rule to a product for a specific branch
export const assignPricingRuleThunk = createAsyncThunk(
  "pricingRules/assign",
  async ({ productId, ruleId, branchCode }, { rejectWithValue }) => {
    try {
      const response = await api.post("/admin-product/assign-pricing-rule", {
        productId,
        ruleId,
        branchCode,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Failed to assign pricing rule"
      );
    }
  }
);

// Remove a pricing rule from a product for a specific branch
export const removePricingRuleThunk = createAsyncThunk(
  "pricingRules/remove",
  async ({ productId, branchCode }, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        `/admin-product/${productId}/pricing-rule/${branchCode}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Failed to remove pricing rule"
      );
    }
  }
);

// ===== ACTIONS =====
export const clearAdminProductError = createAction(
  "adminProduct/clearAdminProductError"
);

export const clearProductPricing = createAction(
  "adminProduct/clearProductPricing"
);

export const clearStockTransferResult = createAction(
  "adminProduct/clearStockTransferResult"
);

export const clearBulkOperationResult = createAction(
  "adminProduct/clearBulkOperationResult"
);

export const clearSelectedProduct = createAction(
  "adminProduct/clearSelectedProduct"
);
